import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { RangeDriver, rangeDriverFactory } from './Range.driver';
import { dataHooks } from 'wix-style-react-tpa/dist/src/Slider/constants';
import { RangeDataHooks } from './types';

export interface RangePrivateDriver extends RangeDriver {
  isSliderDisabled(): Promise<boolean>;
  getSelectedValueText(): Promise<string[]>;
  getMinAriaLabel(): Promise<string>;
  getMaxAriaLabel(): Promise<string>;
}

export const rangePrivateDriverFactory = (
  base: UniDriver,
): RangePrivateDriver => {
  return {
    ...rangeDriverFactory(base),
    isSliderDisabled: async () => {
      return !!base.$('.wsr-slider-disabled');
    },
    getSelectedValueText: async () => {
      const selectedMinValue = await base
        .$(`[data-hook="${RangeDataHooks.SelectedMinValue}"]`)
        .text();
      const selectedMaxValue = await base
        .$(`[data-hook="${RangeDataHooks.SelectedMaxValue}"]`)
        .text();
      return [selectedMinValue, selectedMaxValue];
    },
    getMinAriaLabel: async () => {
      return base
        .$$(`[data-hook="${dataHooks.sliderHandle}"]`)
        .get(0)
        .attr('aria-label');
    },
    getMaxAriaLabel: async () => {
      return base
        .$$(`[data-hook="${dataHooks.sliderHandle}"]`)
        .get(1)
        .attr('aria-label');
    },
  };
};
